import { SCREEN_BREAKPOINT } from "@lib/constants/AppConst";
import { useState, useLayoutEffect } from "react";

export default function useScreen() {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);
  const [isTablet, setIsTablet] = useState<boolean | undefined>(undefined);

  const handleResize = () => {
    setIsMobile(window.innerWidth < SCREEN_BREAKPOINT.mobile);
    setIsTablet(
      window.innerWidth >= SCREEN_BREAKPOINT.mobile &&
        window.innerWidth < SCREEN_BREAKPOINT.tablet,
    );
    setLoading(false);
  };

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobile, isTablet, loading };
}
